import { createContext } from 'react';

const StrainContext = createContext();

export default StrainContext;